import { render, staticRenderFns } from "./TotalNIncome.vue?vue&type=template&id=67ada2ce"
import script from "./TotalNIncome.vue?vue&type=script&lang=js"
export * from "./TotalNIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports